export enum PlaybackState {
	PLAYING = 'PLAYING',
	PAUSED = 'PAUSED',
	BUFFERING = 'BUFFERING',
	LOADING = 'LOADING',
	IDLE = 'IDLE',
}
